// import Ball from "../../ball/Ball";

export default function addBall() {
  if (this.state.wheelCoefs.length > 6) {
    let coefs = this.state.wheelCoefs;
    coefs.shift();
    this.setState({
      wheelCoefs: [...coefs, this.state.wheelCoefs.length],
    });
  } else {
    this.setState({
      wheelCoefs: [...this.state.wheelCoefs, this.state.wheelCoefs.length],
    });
  }
}
